import shareSuccseAds1 from '@/assets/info/shareAndHelpSu1.png'
import shareSuccseAds1b from '@/assets/info/shareAndHelpSu2.png'
//分享完成广告 （弹窗）
//1b增加时间是 9月14 概率为50%
export const SHARE_HREF_IMG_URL1 = shareSuccseAds1
export const SHARE_HREF_IMG_URL1B = shareSuccseAds1b


//1 已停用
export const SHARE_HREF_URL1 =
  'https://m.aibangbaoxian.net/wxAppBusiness?shuntCode=AB2025080511'
export const SHARE_HREF_URL1B =
  'https://m.aibangbaoxian.net/wxAppBusiness?shuntCode=AB2025080511'
